export const WhatsAppQrcodeUrl =
  'https://0.assets.sunionfab.com/ufc-oversea/assets/WhatsAppQrcode.jpg';
